export default __webpack_public_path__ + "static/media/LeBonCoinAi.e493fe50.png";